import { useCallback, forwardRef, useImperativeHandle, useRef } from 'react'

import FilterInput, { FilterInputRefProps } from 'features/common/ui/Forms/FilterInput/FilterInput'
import { Box, styled } from '@mui/material'

const FilterInputWrapper = styled(Box)(() => ({
  flex: 'auto'
}))

export interface MapsSearchBarRefProps {
  clear: () => void
  setValue: (value: string) => void
}

interface MapsSearchBarProps {
  onSearchChange: (search: string) => void
}

const MapsSearchBar: React.ForwardRefRenderFunction<MapsSearchBarRefProps, MapsSearchBarProps> = (
  props,
  forwardedRef
) => {
  const { onSearchChange } = props

  const filterInputRef = useRef<FilterInputRefProps>(null)
  const clear = useCallback(() => {
    if (!filterInputRef.current) return
    filterInputRef.current.clear()
  }, [filterInputRef])

  const setValue = useCallback(
    (value) => {
      if (!filterInputRef.current) return
      filterInputRef.current.setValue(value)
    },
    [filterInputRef]
  )

  useImperativeHandle(forwardedRef, () => ({
    clear,
    setValue
  }))

  return (
    <FilterInputWrapper>
      <FilterInput fullWidth ref={filterInputRef} placeholderId="maps.filters.search" onChange={onSearchChange} />
    </FilterInputWrapper>
  )
}

export default forwardRef(MapsSearchBar)
